import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/homeIndex.vue";
import zlqd from "@/views/ez/Szlqd.vue";
import me from "@/views/ez/Sme.vue";
import login from "../views/login.vue";
import main from "@/views/ez/Smain.vue";
import store from "@/store/index.js";

import {
	Getitem
} from "../utils/item";

Vue.use(VueRouter);

const routes = [{
	path: "/",
	name: '/',
	component: home,
	children: [{
			path: "/zlqd",
			name: 'zlqd',
			component: zlqd,
			children: [],
		},
		{
			path: "/me",
			component: me,
			children: [],
		},
		{
			path: "/main",
			name: 'main',
			component: main,
			children: [],
		},
	],
}, ];

const router = new VueRouter({
	// mode: "history",
	// base: process.env.BASE_URL,
	routes,
});



export default router;